import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type LotteryType = Static<typeof LotteryTypeSchema>;
export const LotteryTypeSchema = Type.Union([Type.Literal('PURCHASE')]);

export type LotteryTypeConsent = Static<typeof LotteryTypeConsentSchema>;
export const LotteryTypeConsentSchema = Type.Object({
  createdAt: Type.String({ format: 'date-time' }),
  lotteryType: LotteryTypeSchema,
  partyUid: Type.String(),
});
